import options from './autocomplete.component';

export default {
    selector: 'dtLabelsAutocomplete',
    options
};
